// Copyright 2023 Sorama B.V.
import { IParameterizedValueConverter2 } from "aurelia-binding-ext";
import { Unit, UnitValue } from "units/Unit";
import { UnitParser } from "units/UnitParser";

export class NumberToUnitValueValueConverter implements IParameterizedValueConverter2<
    UnitValue,
    number,
    Unit | string,
    Unit | string
> {
    public toView(value: number, fromUnit: Unit | string, toUnit?: Unit | string): UnitValue {
        // Make chaining of this converter to a NullToX ValueConverter possible
        if (value === null || value === undefined) {
            return null;
        }

        const fromUnitUnit = typeof fromUnit === "string" ? UnitParser.Parse(fromUnit) : <Unit>fromUnit;
        const fromUnitValue = new UnitValue(value, fromUnitUnit);
        if (!toUnit) return fromUnitValue;

        const toUnitUnit = typeof toUnit === "string" ? UnitParser.Parse(toUnit) : <Unit>toUnit;
        const newUnitValue = toUnitUnit.fromUnit(fromUnitUnit, value);
        return new UnitValue(newUnitValue, toUnitUnit);
    }

    public fromView(value: UnitValue, unit: string | Unit): number {
        throw new Error("Method not implemented.");
    }
}
